export default "__VITE_ASSET__DVfhRW_w__"